#import "../fragments/next-steps-slack-message-fragment.graphql"

mutation FormNextStepsSlackMessageSet($input: FormNextStepsSlackMessageSetInput!) {
    formNextStepsSlackMessageSet(input: $input) {
        slackMessage {
            ...NextStepsSlackMessageFragment
        }
    }
}
